import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const SvgButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;

  border: 1px solid transparent;
  background-color: transparent;
  border-radius: 4px;

  color: ${({ color }) => color};

  i {
    font-size: 24px;
    line-height: 1;
  }

  transition: background-color, border 0.3s;

  cursor: ${({ loading }) => (loading ? 'wait' : 'pointer')};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};

  &:hover {
    border: 1px solid ${({ disabled }) => (disabled ? '' : Colors.Border_Color_1)};
    background: ${({ isDisabled }) => (isDisabled ? '' : Colors.Border_Color_1)};
  }
`;
